// Функция для загрузки любого скрипта используя промис /
export default function loadScript(url, cb) {
  return new Promise(function(resolve, reject) {
    var script = document.createElement("script");
    script.onload = resolve;
    script.async = true;
    script.onerror = reject;
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);

    script.addEventListener('load', () => {
      if (cb) {
        cb();
      }
    });
  });
}
